import { ICotizacion } from './../models/icotizacion';
import { ROUTE_COMERCIAL } from './../constants/constant.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OrdenProduccionService {


    constructor(private apiService: ApiService) { }

    insertarOrdenProduccion(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudOrdenProduccion);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarOrdenProduccion(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudOrdenProduccion);
        return this.apiService.executePutJson(data).pipe();
    }

    calcularOrdenProduccion(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.calcularOPro);
        return this.apiService.executePutJson(data).pipe();
    }

    obtenerOrdenProduccion(numint: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudOrdenProduccion);
        return this.apiService.execGetQueryJson(`/${numint}`).pipe();
    } execGetQueryJsonPDF

    buscarOrdenProduccion(fdesde: string, fhasta: string, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.buscarOPro);
        return this.apiService.execGetQueryJson(`?fdesde=${fdesde}&fhasta=${fhasta}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`).pipe();
    }

    buscarOrdenProduccion2(fdesde: any, fhasta: any, codven: any, codsuc: number, codcli: any, codmot: any, situac: any, offset: any, limit: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.buscarOPro);
        return this.apiService.execGetQueryJson(`?fdesde=${fdesde}&fhasta=${fhasta}&codven=${codven}&codsuc=${codsuc}&codcli=${codcli}&codmot=${codmot}&situac=${situac}&offset=${offset}&limit=${limit}`).pipe();
    }

    descargarPDF(formato: number, numint: number, cia: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudOrdenProduccion);
        if(formato === 1){
            //return this.apiService.execGetQueryJsonPDF(`/${numint}/report/public/format-1.pdf?cia=${cia}`).pipe();
            return this.apiService.execGetQueryJsonPDF(`/${numint}/report/public/format-default.pdf?cia=${cia}`).pipe();
            //fullUrl = environment.serviceUrl + `OrdenProduccion/${numint}/report/public/format-default.pdf?` + "cia=" + cia;
        }
        if(formato === 2){
            return this.apiService.execGetQueryJsonPDF(`/${numint}/report/public/format-2.pdf?cia=${cia}`).pipe();
        }
    }

    reutilizar(serie : number, numdoc : number){
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudOrdenProduccion);
        return this.apiService.execGetQueryJson(`/${serie}/${numdoc}`).pipe();
      }

    buscarCotizacion(femisi : any , moneda : string , codsuc : number , codcli : string): Observable<any> {
        this.apiService.setUrlPathApi('cotizacion/buscar/pendientes-aprobados');
        return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
    }

    buscarPendientes(femisi : any , moneda : string , codmot : number , codsuc : string, codcli : string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudOrdenProduccion+'/buscar/pendientes');
        return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codmot=${codmot}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
    }

    
}